import { Button } from '../Button/Button'
import { ParagraphComposition } from '../ParagraphComposition/ParagraphComposition'
import { Container, Link } from './ParagraphCompositionWithCta.styles'
import type { ParagraphCompositionWithCtaProps } from './ParagraphCompositionWithCta.types'

export const ParagraphCompositionWithCta = ({
  upperTitle,
  title,
  description,
  cta,
}: ParagraphCompositionWithCtaProps): JSX.Element => {
  return (
    <Container>
      <ParagraphComposition
        title={title}
        upperTitle={upperTitle}
        paragraph={description}
      />
      <Link>
        <Button
          fullWidth
          variant="ghost"
          as="a"
          href={cta.url}
          text={cta.text}
        />
      </Link>
    </Container>
  )
}
